module.exports = {
    ja: "ja",
    en: "en",
    ko: "ko",
    vi: "vi",
    th: "th",
    "zh-TW": "zh-TW",
    "zh-CN": "zh-CN"
};
